import { ButtonHTMLAttributes, forwardRef, useImperativeHandle, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { MyButtonRef } from '../models/ButtonProps';

export interface MyButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  proceed: () => void;
}

const ButtonDeleteMenu = forwardRef<MyButtonRef, MyButtonProps>((props, ref) => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);

  // Define custom event handlers
  useImperativeHandle(ref, () => ({
    focus: () => {
      buttonRef.current?.focus();
    },
    disable: () => {
      buttonRef.current?.setAttribute('disabled', 'true');
    },
    enable: () => {
      buttonRef.current?.removeAttribute('disabled');
    },
    blur: () => {
      buttonRef.current?.blur();
    },
  }));

  return (
    <>
      <button type="button" ref={buttonRef} onClick={props.proceed} className="btn btn-danger">
        {t('MenuList.Button.delete')}
      </button>
    </>
  );
});

export default ButtonDeleteMenu;
